<template>
  <div class="station-file-content">
    <a-tabs
      style="width: 100%"
      :default-active-key="tabValue"
      :value="tabValue"
      @change="changeTab"
      size="small"
    >
      <a-tab-pane key="1" :tab="$t('page_dnc_station_file_internal_gateway_file')"> </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('page_dnc_station_file_cloud_path_file')"> </a-tab-pane>
    </a-tabs>
    <component
      :is="componentId"
      :treeInfo="treeInfo"
      :selectedKey="selectedKeys.length ? selectedKeys[0] : ''"
    ></component>
  </div>
</template>

<script>
import CloudPath from './CloudPath.vue'
import InternalGateway from './InternalGateway.vue'
export default {
  components: {
    CloudPath,
    InternalGateway
  },
  data() {
    return {}
  },
  computed: {
    componentId() {
      let isComponent = ''
      switch (this.tabValue) {
        case '1':
          isComponent = 'internal-gateway'
          break
        case '2':
          isComponent = 'cloud-path'
          break
      }
      return isComponent
    }
  },
  props: {
    selectedKeys: {
      // 选择树节点
      type: Array,
      default: () => []
    },
    treeInfo: {
      type: Object,
      default: () => ({})
    },
    tabValue: {
      type: String,
      default: '1'
    }
  },
  methods: {
    changeTab(value) {
      this.$emit('changeTab', value)
    }
  }
}
</script>

<style lang="less" scoped>
.station-file-content {
  width: calc(100% - 321px);
  height: 100%;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;

  /deep/ .ant-tabs {
    overflow: inherit;
  }

  /deep/ .ant-tabs-bar {
    bottom: -1px;
    border-bottom: 1px solid #d9d9d9;
    margin: 0;
  }

  /deep/ .ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
    padding: 9px 16px;
    margin: 0;
    width: 160px;
    text-align: center;
  }

  /deep/ .ant-tabs-nav {
    width: 100%;
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab {
    border-right: 1px solid #d9d9d9;
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab-active {
    background-color: #fff;
  }

  /deep/ .ant-tabs-ink-bar {
    top: -1px !important;
    z-index: 99;
    background-color: #4a90e2;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    bottom: auto;
    height: 4px;
  }
  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
    visibility: hidden;
  }

  /deep/ .ant-tree-treenode-selected > span .right-drop-down {
    display: block !important;
  }

  /deep/ .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
    background-color: transparent;
  }

  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
    opacity: 0 !important;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper {
    width: calc(100% - 24px);
    /*background-color: #d0edff;*/
  }

  /deep/ .ant-tree-title {
    position: relative;
  }

  /deep/ .ant-tree-switcher {
    color: rgba(0, 0, 0, 0) !important;
    position: relative;
    z-index: 99;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: rgb(255, 241, 184);
  }
}
</style>
